import Modeler from 'bpmn-js/lib/Modeler'
import $ from 'jquery'

import { Logger, LoggerTypes } from '../../../../utils'

/**
 * Import Diagram.
 *
 * @param {string} xml XML content.
 * @param {Modeler} modeler Modeler element.
 */
const bpmnImportDiagram = async (xml, modeler) => {
  const viewer = $(modeler._container)
  try {
    await modeler.importXML(xml)
    if (viewer) {
      viewer.removeClass('with-error').addClass('with-diagram')
    }
    Logger.trace(LoggerTypes.BPMN, 'bpmnImportDiagram()', { viewer, xml, modeler })
  } catch (err) {
    if (viewer) {
      viewer.removeClass('with-diagram').addClass('with-error')
      viewer.find('.error pre').text(err.message)
    }
    Logger.trace(LoggerTypes.WARN, 'bpmnImportDiagram()', { viewer, xml, modeler })
  }
}

/**
 *
 * @param {string} xml XML File.
 * @param {Modeler} modeler Modeler element.
 * @param {boolean} clear Is data to be cleared.
 */
export const bpmnLoadXMLDiagram = (xml, modeler, clear = true) => {
  if (clear) {
    Logger.trace(LoggerTypes.BPMN, 'bpmnLoadXMLDiagram()', { xml, modeler, clear })
    bpmnImportDiagram(xml, modeler)
  } else {
    let importer = new Modeler()
    modeler.isImportXML = true

    // Catch the end event of the creation of all elements in the designer
    modeler.get('eventBus').on('create.end', (e) => {
      Logger.trace(LoggerTypes.BPMN, 'bpmnLoadXMLDiagram().get(eventBus).on(create.end)', e)

      if (modeler.isImportXML) {
        modeler.isImportXML = false
      }
    })

    importer.get('eventBus').on('import.done', (e) => {
      // Retrieve all imported elements
      let rootElement = importer.get('canvas').getRootElement()
      let elements = importer.get('elementRegistry').filter((element) => {
        return element !== rootElement
      })

      // Use the selection object of the importer to select them and activate the copyPaste
      let selection = importer.get('selection')
      selection.select(elements)
      let selectedElements = selection.get()
      importer.get('copyPaste').copy(selectedElements)

      let clipboard = modeler.get('clipboard')
      let copied = importer.get('clipboard').get()
      clipboard.set(copied)

      Logger.trace(LoggerTypes.BPMN, 'bpmnLoadXMLDiagram().get(eventBus).on(import.done)', { e, clipboard, copied })

      modeler.get('copyPaste').paste()
    })

    bpmnImportDiagram(xml, importer)
  }
}

/**
 * Import XML
 *
 * @param {string} file File path to load.
 * @param {object} modeler Modeler.
 * @returns {void}
 */
export const bpmnLoadXMLFile = (file, modeler) => {
  const reader = new FileReader()

  Logger.trace(LoggerTypes.BPMN, 'bpmnLoadXMLFile()', { file, modeler })

  reader.onload = (e) => {
    bpmnLoadXMLDiagram(e.target.result, modeler)
  }
  reader.readAsText(file)
}

// ----------------------------------------
// Drag & Drop functions
// ----------------------------------------
/*
export registerFileDrop = (viewer, callback) => {

  const handleFileSelect = (e) => {
    e.stopPropagation();
    e.preventDefault();

    var files = e.dataTransfer.files;
    var file = files[0];
    _loadXMLFile(file, callback);
  }

  const handleDragOver = (e) => {
    e.stopPropagation();
    e.preventDefault();

    e.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
  }

  viewer.get(0).addEventListener('dragover', handleDragOver, false);
  viewer.get(0).addEventListener('drop', handleFileSelect, false);
}

// check file api availability
if (!window.FileList || !window.FileReader) {
  window.alert(
    'Looks like you use an older browser that does not support drag and drop. ' +
    'Try using Chrome, Firefox or the Internet Explorer > 10.');
} else {
  registerFileDrop(viewer, _loadXMLDiagram);
}
*/
